import { useRef } from 'react';
import PropTypes from 'prop-types';
import useTranslation from 'next-translate/useTranslation';

// Components
import Modal from '@/components/base/Modal';
import Button from '@/components/base/Button';
import InfoBanner from '@/components/base/InfoBanner';

const CommentDeleteModal = ({
    isOpen,
    toggle,
    deleteComment,
    isLoading = false,
    isError = false
}) => {
    const { t } = useTranslation('commons');
    const initRef = useRef(null);

    return (
        <Modal open={isOpen} onDismiss={toggle} initialFocus={initRef} className="!z-100">
            <Modal.Body>
                {isError && (
                    <InfoBanner
                        className="mb-8 text-left"
                        title={t('errors:error')}
                        message={t('errors:error_comment_delete')}
                    />
                )}
                <Modal.Title>{t('comment.delete_comment')}</Modal.Title>
                <Modal.Content className="pt-m text-center font-GMedium text-icoGray-500">
                    {t('comment.delete_comment_confirmation')}
                </Modal.Content>
                <Modal.Footer
                    className="flex flex-col items-center justify-between space-y-3 pb-12 pt-8 xs:flex-row xs:space-x-3 xs:space-y-0"
                    divider={false}>
                    <Button variant="secondary" className="w-full" onClick={toggle}>
                        {t('commons:no')}
                    </Button>
                    <Button isLoading={isLoading} onClick={deleteComment} className="w-full">
                        {t('commons:yes')}
                    </Button>
                </Modal.Footer>
            </Modal.Body>
        </Modal>
    );
};

CommentDeleteModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    deleteComment: PropTypes.func.isRequired,
    isLoading: PropTypes.bool
};

export default CommentDeleteModal;
